import { useCallback, useMemo } from "react";
import { Stack, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import { getSpecimenIdentifierErrors } from "../../utils/specimenIdentifiers";

interface GrossingSpecimenIdentifierEditorProps {
  form: UseFormReturnType<any>;
  onIdentifierChange: (index: number, value: string) => void;
}

export default function GrossingSpecimenIdentifierEditor({
  form,
  onIdentifierChange,
}: GrossingSpecimenIdentifierEditorProps) {
  const specimens = useMemo(
    () => form.values.case.specimens || [],
    [form.values.case.specimens]
  );
  const errors = useMemo(
    () => getSpecimenIdentifierErrors(specimens),
    [specimens]
  );
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onIdentifierChange(
        Number(event.currentTarget.dataset.index),
        event.currentTarget.value
      );
    },
    [onIdentifierChange]
  );
  return (
    <Stack gap="sm">
      {specimens.map(
        (specimen: { id?: string; number: string }, index: number) => (
          <TextInput
            key={specimen.id || index}
            label={`Specimen ${index + 1} identifier`}
            data-index={index}
            value={specimen.number}
            onChange={handleChange}
            error={errors[index]}
            required
          />
        )
      )}
    </Stack>
  );
}
